import { ChangeEvent, useState } from "react";
import { useAdmin } from "../../../context/admin";
import Modal from "../../common/Modal";
import { Payment, ReservationPayment } from "../../../types/common.types";
import GeneralInput from "../../common/GeneralInput";
import Dropdown from "../../common/Dropdown";
import FileInput from "../../common/FileInput";
import { AiFillCloseCircle } from "react-icons/ai";
import jsonToFormData from "../../../utils/jsonToFormData";
import AdminService from "../../../services/admin.service";

// used for single reservations
// not traspax
export default function EditPaymentReservation() {
    const { editPaymentReservationData, setEditPaymentReservationData, 
        setViewPaymentsData } = useAdmin()
    const [newData, setNewData] = useState<ReservationPayment>(editPaymentReservationData as ReservationPayment)
    function onChange(e: ChangeEvent<HTMLInputElement>) {
        const name = e.target.name
        let value: string | number
        if (e.target.type === 'number') {
            value = Number(e.target.value)
        } else {
            value = e.target.value
        }
        setNewData(prevData => ({...prevData, [name]: value}))
    }

    function onChangeFiles(newFile: File | undefined, name: keyof ReservationPayment) {
        console.log(newFile)
        setNewData(prevData => ({...prevData, [name]: newFile}))
    }

    async function onSubmit(e: React.FormEvent<HTMLFormElement>) {
        e.preventDefault()
        try {
            const formattedData = {
                amount: (!newData.amount || newData.amount?.toString() === 'null') ? 0 : newData.amount,
                remarks: newData.remarks,
                amount_tickets: (!newData.amount_tickets || newData.amount_tickets?.toString() === 'null') ? 0 : newData.amount_tickets,
                pic: newData.pic,
            }
            const formData = jsonToFormData(formattedData)
            await AdminService.editReservationPayment(editPaymentReservationData!.id, formData)
            setEditPaymentReservationData(undefined)
            setViewPaymentsData(prev => {
                if (!prev) return prev
                const index = prev.findIndex(p => p.id === editPaymentReservationData!.id)
                prev[index] = {...prev[index], ...formattedData}
                return [...prev]
            })
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal onSubmit={onSubmit}>
            <h1>Edit Payment</h1>
            <GeneralInput
            label="Amount"
            placeholder="10.000"
            value={newData.amount?.toString() || ''}
            onChange={onChange}
            type="number"
            name="amount"
            />
            <GeneralInput
            label="Amount tickets"
            placeholder="5.000"
            value={newData.amount_tickets?.toString() || ''}
            onChange={onChange}
            type="number"
            name="amount_tickets"
            />
            <GeneralInput
            label="Remarks"
            value={newData.remarks}
            onChange={onChange}
            name="remarks"
            style={{margin: '20px 0'}}
            />
            <FileInput
            style={{margin: '10px 0'}}
            value={newData!.pic}
            deleteFile={() => onChangeFiles(undefined, 'pic')}
            accept=".png, .jpg, .jpeg, .heic"
            onChange={(newFile: File) => onChangeFiles(newFile, 'pic')}
            />
            <div className="actions">
                <button type="submit" className="save">Save</button>
            </div>
            <div className="close">
                <AiFillCloseCircle onClick={() => setEditPaymentReservationData(undefined)}/>
            </div>
        </Modal>
    )
}